import React from 'react';

import styled from 'styled-components';
import { FlexContainer } from 'styles/common';

import { ButtonOutlined } from 'uiToolkit/Button';
import { Typography13, Typography6 } from 'uiToolkit/Typography';

const NoTasksComponent = ({ img = '', heading = '', subHeading = '', onButtonClick = () => {}, buttonText = '' }) => (
  <FlexContainer
    style={{
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      padding: '1rem',
      marginTop: '1rem',
    }}
  >
    <StyledImage src={img} />
    <Typography6 topGutter={2}>{heading}</Typography6>
    <Typography13 align="center" topGutter={1}>
      {subHeading}
    </Typography13>
    <ButtonOutlined style={{ marginTop: '2rem' }} color="primary" onClick={onButtonClick}>
      <Typography13 color="primary">{buttonText}</Typography13>
    </ButtonOutlined>
  </FlexContainer>
);

const StyledImage = styled.img`
  width: 10rem;
`;

export default NoTasksComponent;
